import { Category, ConnectorUpsertDto, ProviderDto } from '@ampsec/platform-client';

export const RECONCILIATION_ASSET_SOURCE_OF_TRUTH_SETTING_KEY =
    'RECONCILIATION_ASSET_ATTRIBUTION_SOURCE_OF_TRUTH_CONNECTOR_ID';

export const AUTOMATIC_ASSET_ATTRIBUTION_SOURCE_LABEL = 'Automatic (recommended)';
export const ASSET_ATTRIBUTION_SOURCE_BADGE_LABEL = 'Primary attribution source';

const ASSET_ATTRIBUTION_SOURCE_CATEGORIES: Category[] = [
    Category.ATTRIBUTION,
    Category.ENDPOINT_MANAGEMENT,
    Category.ENDPOINT_SECURITY,
    Category.EDR,
];

export type AttributionSourceOption = {
    label: string;
    cid: string;
};

export const parseAttributionSourceConnectorId = (value: unknown): string | undefined => {
    if (typeof value === 'string') {
        const trimmedValue = value.trim();
        return trimmedValue.length > 0 ? trimmedValue : undefined;
    }

    if (Array.isArray(value)) {
        const firstValue = value.find((entry) => typeof entry === 'string' && entry.trim().length > 0);
        return typeof firstValue === 'string' ? firstValue.trim() : undefined;
    }

    if (value && typeof value === 'object') {
        const maybeConnectorId = (value as { connectorId?: unknown; cid?: unknown; id?: unknown }).connectorId ??
            (value as { connectorId?: unknown; cid?: unknown; id?: unknown }).cid ??
            (value as { connectorId?: unknown; cid?: unknown; id?: unknown }).id;
        if (typeof maybeConnectorId === 'string' && maybeConnectorId.trim().length > 0) {
            return maybeConnectorId.trim();
        }
    }

    return undefined;
};

export const getAttributionSourceOptions = (
    connectors: ConnectorUpsertDto[] = [],
    providers: ProviderDto[] = [],
): AttributionSourceOption[] => {
    const providerById = new Map(providers.map((provider) => [provider.id, provider]));

    return connectors
        .filter((connector) => {
            const provider = providerById.get(connector.pid ?? '');
            const categories = provider?.categories ?? [];
            return categories.some((category) =>
                ASSET_ATTRIBUTION_SOURCE_CATEGORIES.includes(category as Category),
            );
        })
        .map((connector) => ({
            cid: connector.id ?? '',
            label: connector.displayValue ? `${connector.displayValue} (${connector.id})` : connector.id ?? '',
        }))
        .filter((option) => option.cid.length > 0 && option.label.length > 0)
        .sort((a, b) => a.label.localeCompare(b.label));
};
